import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Form } from '../Dto/Form';
import { FormAnswer } from '../Dto/FormAnswer';
import { Consent } from '../Dto/Consent';

@Injectable()
export class FormsService {

  constructor(private http: HttpClient) {
  }

  getFormUrl = environment.settings.apiEndpoint + '/api/Forms/GetForm';
  saveFormUrl = environment.settings.apiEndpoint + '/api/Forms/SaveForm';
  authorizeFormAnswerUrl = environment.settings.apiEndpoint + '/api/Forms/AuthorizeFormAnswer';
  getCurrentConsentUrl = environment.settings.apiEndpoint + '/api/Forms/GetCurrentConsent';
  getMissingConsentUrl = environment.settings.apiEndpoint + '/api/Forms/GetMissingConsent';
  addConsentUrl = environment.settings.apiEndpoint + '/api/Forms/AddConsent';

  getForm(guid: string) {
    return this.http.get<Form>(this.getFormUrl + '/' + guid);
  }

  saveForm(answers: FormAnswer) {
    return this.http.post<FormAnswer>(this.saveFormUrl, answers);
  }

  authorizeFormAnswer(guid: string, email: string) {
    let params = new HttpParams();
    params = params.append('guid', guid);
    params = params.append('email', encodeURIComponent(email));
    return this.http.get<FormAnswer>(this.authorizeFormAnswerUrl, { params });
  }

  getCurrentConsent() {
    return this.http.get<Consent>(this.getCurrentConsentUrl);
  }

  getMissingConsent(guid: string, email: string) {
    let params = new HttpParams();
    params = params.append('guid', guid);
    params = params.append('email', encodeURIComponent(email));
    return this.http.get<Consent>(this.getMissingConsentUrl, { params });
  }

  addConsent(guid: string, email: string) {
    let params = new HttpParams();
    params = params.append('guid', guid);
    params = params.append('email', email);
    return this.http.get<FormAnswer>(this.addConsentUrl, { params });
  }
}


